module.exports = __webpack_public_path__ + "img/training-ski.e14b7c65.svg";